export default function CookieReader(cookieName) {
    if (typeof (document) !== 'undefined') {
        var name = cookieName + '='
        var ca = document.cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }
    }
    return ''
}

export function GetBrowserUserValues(){
    const userVin = CookieReader('VIN')
    const userGuid = CookieReader('WebUserGuid')
    const isBot = (userVin || '').toLowerCase().startsWith('bot-')

    // Default isGpcEnabled to false, otherwise we will break all tracking services in Chrome. Ideally we'd
    // default to true if we don't know if they want GPC enabled but Chrome prevents us from doing so :(
    const isWindowGpcEnabled = navigator?.globalPrivacyControl ?? false
    const isGpcEnabled = 
        // This is used for Selenium testing. The tests should be able to manually set this in order
        // to assert if tracking happens or not
        CookieReader("EnableGpc") 
        || isWindowGpcEnabled

    const cookies = {
        userVin,
        userGuid,
        isBot,
        isEmployee: CookieReader('ExcludeIpFromAnalytics') || CookieReader('ExcludeEmailFromAnalytics'),
        isGpcEnabled
    }
    return cookies
}

export function DeleteCookie(name) {
    if (typeof (document) !== 'undefined') {
        document.cookie = `${name}=; path=/; domain=${document.location.host}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
}

